"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromotionModal = PromotionModal;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function PromotionModal(_ref) {
  var isOpen = _ref.isOpen,
    onSelect = _ref.onSelect;
  if (!isOpen) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "Choose piece for promotion"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onSelect("q");
    }
  }, "Queen"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onSelect("r");
    }
  }, "Rook"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onSelect("b");
    }
  }, "Bishop"), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return onSelect("n");
    }
  }, "Knight"));
}